import { Point } from '../../drawing';
import { PositionAdjustments } from '../constants';


export class NabcSignificantLetter {
  private _letter: string;

  get letter() {
    return this._letter;
  }

  get position(): number {
    return +this._letter[this._letter.length - 1];
  }

  get glyph(): string {
    return this._letter.slice(0, this._letter.length - 1);
  }

  get positionAdjustment(): Point {
    return PositionAdjustments[this.position];
  }

  constructor(
    letter: string,
  ) {
    this._letter = letter;
  }
}
